export default __webpack_public_path__ + "static/media/terminator-rpg.0f2d042f.jpg";